import type { Card } from './data/cards/types';
import { cardsByTier } from './data/cards';
import { rollCardTier } from './data/gameConfig';

// Rolls a 5-card shop for the given tavern tier using TAVERN_ROLL_TABLE.
// Cards are shop-eligible (not starters, not tokens). Returns fresh
// instances so each shop slot has its own instanceId — the buyer's
// hand gets an instance distinct from the shop slot it came from.

const SHOP_SIZE = 5;

function newInstanceId(): string {
  return typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `i_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 9)}`;
}

function pickFromTier(tier: number, rng: () => number): Card {
  const pool = cardsByTier[tier] || cardsByTier[1];
  const idx = Math.floor(rng() * pool.length);
  return pool[idx];
}

export function rollShop(
  tavernTier: number,
  rng: () => number = Math.random,
  size: number = SHOP_SIZE,
): Card[] {
  const shop: Card[] = [];
  for (let i = 0; i < size; i++) {
    const tier = rollCardTier(tavernTier, rng);
    const template = pickFromTier(tier, rng);
    shop.push({ ...template, instanceId: newInstanceId() });
  }
  return shop;
}

export function newInstance(card: Card): Card {
  return { ...card, instanceId: newInstanceId() };
}
